import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import moment from "moment";
import { IDocument } from "../../models/document.model";
import styles from "./DocumentView.module.scss";
import { useTranslation } from "react-i18next";
import { OpenIcon } from "../../assets/icons";
import DocumentDownload from "../DocumentDownload";

interface Props {
  showVersion?: boolean;
  document: IDocument | IDocument[];
  hideOpenOnline?: boolean;
}

const DocumentView: React.FC<Props> = ({ showVersion, document, hideOpenOnline }) => {
  const { t } = useTranslation();

  const _documents = Array.isArray(document) ? [...document] : [document];

  return (
    <TableContainer className={styles.documentView}>
      <Table>
        <TableHead>
          <TableRow>
            {showVersion && <TableCell className={styles.version}>{t("version")}</TableCell>}
            <TableCell>{t("uploadBy")}</TableCell>
            <TableCell className={styles.uploadDate}>{t("uploadDate")}</TableCell>
            <TableCell className={styles.document}>{t("document")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {_documents.map((x) => (
            <TableRow key={`document_view_id_${x.id}`}>
              {showVersion && <TableCell className={styles.version}>{x.version}</TableCell>}
              <TableCell>{x.updatedBy}</TableCell>
              <TableCell className={styles.uploadDate}>
                {x.updatedDate ? moment(x.updatedDate).format("MM/DD/YYYY") : ""}
              </TableCell>
              <TableCell className={styles.document}>
                <DocumentDownload documentId={x.id} />
                {!hideOpenOnline && (
                  <IconButton onClick={() => window.open(x.link, "_blank")?.focus()}>
                    <OpenIcon />
                    <p>{t("openOnline")}</p>
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DocumentView;
